
import { createRouter, createWebHistory, isNavigationFailure } from 'vue-router';
import { store } from '@/store';
import auth from '@/utils/auth';
import lookupRouter from '@/router/lookup'; // 投保後查詢
import calculator from '@/router/calculator'; // 保費試算
import insureOwner from '@/router/insure/owner'; // 投保 - 要被保同人
import checkout from '@/router/checkout';
import insureAgent from '@/router/insure/agent'; // 投保 - 要被不保同人
import insureCorporation from '@/router/insure/corporation'; // 投保 - 企業
import login from '@/router/login';
import register from '@/router/register';
import renewal from '@/router/renewal';

/* pages */
const MainHeader = () => import('@/components/MainHeader');
const Home = () => import('@/views/common/Home');
const CarHelper = () => import('@/views/car/Helper');
const Combination = () => import('@/views/common/Combination');
const Event = () => import('@/views/common/Event');
const Faq = () => import('@/views/common/Faq');
const Share = () => import('@/views/common/Share');
const Plan = () => import('@/views/common/Plan');
const E404 = () => import('@/views/error/404');
const Maintain = () => import('@/views/error/Maintain');

const routes = [
    {
        path: '/',
        name: 'DefaultHome',
        redirect: to => { 
            // 把首頁的路由導向到車險首頁
            return { path: '/car', query: { ActivityCode: to.query.ActivityCode, iChannels: to.query.iChannels, EstimateId: to.query.EstimateId } };
        }
    },
    {
        path: '/logout',
        name: 'Logout',
        beforeEnter: (to, from, next) => {
            store.commit('auth/logout');
            next(from.path);
        }
    },
    {
        path: '/:type(car|motor)',
        name: 'Home',
        components: {
            default: Home,
            header: MainHeader
        },
        // beforeEnter: (to, from, next) => {
        //     if (to.params.type === 'car') {
        //         to.matched[0].components.default = CarHome;
        //     } else if (to.params.type === 'motor') {
        //         to.matched[0].components.default = MotorHome;
        //     }
        //     next();
        // }
    },
    {
        path: '/:type(car|motor)/combination/:id',
        name: 'Combination',
        components: {
            default: Combination,
            header: MainHeader
        },
        props: {
            default: true,
            header: false
        }
    },
    {
        path: '/:type(car|motor)/helper',
        name: 'CarHelper',
        components: {
            default: CarHelper,
            header: MainHeader
        }
    },
    {
        path: '/:type(car|motor)/faq',
        name: 'Faq',
        components: {
            default: Faq,
            header: MainHeader
        }
    },
    {
        path: '/:type(car|motor)/event/:id',
        name: 'Event',
        components: {
            default: Event,
            header: MainHeader
        }
    },
    {
        path: '/:type(car|motor)/share/:dk',
        name: 'Share',
        components: {
            default: Share,
            header: MainHeader
        }
    },
    {
        path: '/:type(car|motor)/plan',
        name: 'PlanLogin',
        components: {
            default: Plan,
            header: MainHeader
        }
    },
    {
        path: '/:type(car|motor)/maintain',
        name: 'Maintain',
        components: {
            default: Maintain,
            header: MainHeader
        }
    },
    {
        path: '/:type(car|motor)/404',
        name: 'E404',
        components: {
            default: E404,
            header: MainHeader
        },
    },
    {
        path: '/:catchAll(.*)*',
        name: 'CatchAll',
        redirect: (to) => { 
            let type = to?.fullPath?.includes('motor') ? '/motor' : '/car';
            return { path: `${type}/404` };
        }

    },...lookupRouter,...calculator,...insureOwner,...checkout,...insureAgent,...insureCorporation,...login,...register,...renewal
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            if (to.hash) {
                return {
                    el: to.hash,
                    behavior: 'smooth'
                };
            }
            return {top: 0, left: 0};
        }
    }
});

const originalPush = router.push;
router.push = function push(location, onResolve, onReject) {
    if (onResolve || onReject){
        return originalPush.call(this, location, onResolve, onReject);
    }
       
    return originalPush.call(this, location).catch((err) => {
        if (isNavigationFailure(err)) {
            store.commit('closeLoading');
            return Promise.reject(err);
        }
        store.commit('closeLoading');
        //解決前端cache導致js載入錯誤
        const pattern = /Loading (.+)?chunk (.)+ failed/g;//Loading CSS chunk ...、Loading chunk ...
        const isChunkLoadFailed = err.message.match(pattern);
        const targetPath = location;
        if (isChunkLoadFailed && !!location) {
            store.commit('router/setTargetPath', targetPath);
            window.location.reload();
        }
        return Promise.resolve(false);
    });
};

router.beforeEach((to, from, next) => {
    store.commit('showLoading');
    next();
});

router.afterEach((to, from) => {
    auth.passiveRefreshToken();
    store.commit('navigationDrawerClose');
    store.commit('hideAllSubmenu');
    store.commit('closeLoading');
});

router.isReady().then(()=>{
    const targetPath = store.state.router.targetPath;
    const tryReload = store.state.router.tryReload;
    if(targetPath) {
        if(!tryReload){
            router.replace(targetPath);
            store.commit('router/setTryReload', true);
            store.commit('router/setTargetPath', null);
        }
        else{
            store.commit('router/setTryReload', false);
        }
    }
}).catch();

export default router;